<template>
  <form>
    <h4 class="card-title">{{$t('medium_grant.technical__3_organisational_capacity')}}</h4>
    <p>
      {{$t('medium_grant.technical__3_organisational_capacity_sub')}}
    </p>
    <div class="row">
      <div class="col-lg-12">
        <base-input>
            <textarea
              class="form-control"
              :placeholder="$t('medium_grant.general__write_here')"
              v-model="GrantForm.revisionModel.technical.organisationalCapacity"
            >
            </textarea>
        </base-input>

        <p class="mt-5 mb-2">{{$t('medium_grant.technical__3_attach_org_last_activity')}}</p>
        <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.technical.revisionOrgLastActivityReport" :file-data="GrantForm.files.technical.revisionOrgLastActivityReport" :is-editable="GrantForm.isRevisionEditable" :size-limit="GrantForm.fileSizeLimit" section="technical.revisionOrgLastActivityReport"></upload-file>

        <p class="mt-5">
          {{$t('medium_grant.technical__3_organisational_capacity_indicate')}}
        </p>

        <table class="mt-3" width="100%">
          <thead>
          <th>{{$t('medium_grant.general__name')}}</th>
          <th>{{$t('medium_grant.general__org')}}</th>
          <th>{{$t('medium_grant.general__current_position_job')}}</th>
          <th>{{$t('medium_grant.general__upload_cv')}}</th>
          </thead>
          <tbody>
          <tr v-for="(individual, index) in detailsOfIndividuals" :key="index">
            <td>
              <div class="form-group">
          <textarea
            class="form-control"
            v-model="individual.name"
            :placeholder="$t('medium_grant.general__name')"
          >
          </textarea>
              </div>
            </td>
            <td>
              <div class="form-group">
          <textarea
            class="form-control"
            v-model="individual.organisation"
            :placeholder="$t('medium_grant.general__org')"
          >
          </textarea>
              </div>
            </td>
            <td>
              <div class="form-group">
          <textarea
            class="form-control"
            v-model="individual.position"
            :placeholder="$t('medium_grant.general__position')"
          >
          </textarea>
              </div>
            </td>
            <td class="vertical-align-baseline">
              <upload-file v-model="GrantForm.files.technical['revisionIndividuals' + (index+1)]" :file-data="GrantForm.files.technical['revisionIndividuals' + (index+1)]" :is-editable="GrantForm.isRevisionEditable" :size-limit="GrantForm.fileSizeLimit" :section="'technical.revisionIndividuals' + (index + 1)"></upload-file>
            </td>
          </tr>
          </tbody>
          <base-button v-if="detailsOfIndividuals.length < maxDetailsOfIndividuals" @click="addDetailsOfIndividualsRow" type="primary" class="btn-simple" size="sm">
            + {{$t('general.add_row')}}
          </base-button>
        </table>

        <p class="mt-5">
          {{$t('medium_grant.technical__3_organisational_capacity_is_involved')}}
        </p>

        <div>
          <div class="form-check form-check-radio form-check-inline">
            <radio name="technical.isInvolvedInOther"
                   inline value="true"
                   v-validate="'required'"
                   :data-vv-as="$t('general.field')"
                   v-model="GrantForm.revisionModel.technical.isInvolvedInOther"
            >
              {{$t('medium_grant.general__yes')}}
            </radio>
            <radio name="technical.isInvolvedInOther" inline value="false" v-model="GrantForm.revisionModel.technical.isInvolvedInOther">
              {{$t('medium_grant.general__no')}}
            </radio>
          </div>
          <div>
            <label v-if="getError('technical.isInvolvedInOther')" class="text-danger">{{getError('technical.isInvolvedInOther')}}</label>
          </div>
        </div>

        <table class="mt-3" width="100%">
          <thead>
          <th>{{$t('medium_grant.general__title')}}</th>
          <th>{{$t('medium_grant.general__role')}}</th>
          <th>{{$t('medium_grant.general__partners')}}</th>
          </thead>
          <tbody>
          <tr v-for="(involved, index) in detailsOfInvolved" :key="index">
            <td>
              <div class="form-group">
          <textarea
            class="form-control"
            v-model="involved.title"
            :placeholder="$t('medium_grant.general__title')"
          >
          </textarea>
              </div>
            </td>
            <td>
              <div class="form-group">
          <textarea
            class="form-control"
            v-model="involved.role"
            :placeholder="$t('medium_grant.general__role')"
          >
          </textarea>
              </div>
            </td>
            <td>
              <div class="form-group">
          <textarea
            class="form-control"
            v-model="involved.partners"
            :placeholder="$t('medium_grant.general__partners')"
          >
          </textarea>
              </div>
            </td>
          </tr>
          </tbody>
          <base-button v-if="detailsOfInvolved.length < maxDetailsOfInvolved" @click="addDetailsOfInvolvedRow" type="primary" class="btn-simple" size="sm">
            + {{$t('general.add_row')}}
          </base-button>
        </table>

        <p class="mt-4">
          {{$t('medium_grant.technical__3_organisational_sub_note')}}
        </p>
      </div>
    </div>
  </form>
</template>
<script>
  import {GrantForm} from "@/services";
  import {BaseRadio} from 'src/components/index';
  import {EventBus} from '@/event-bus.js';

  export default {
    data() {
      return {
        GrantForm,
        detailsOfIndividuals: [],
        detailsOfInvolved: [],
        maxDetailsOfIndividuals: 10,
        maxDetailsOfInvolved: 10,
      }
    },
    components: {
      BaseRadio
    },
    methods: {
      addDetailsOfIndividualsRow() {
        if (this.detailsOfIndividuals.length >= this.maxDetailsOfIndividuals) return;
        this.detailsOfIndividuals.push({
          name: '',
          organisation: '',
          position: '',
          cv: ''
        });
      },
      addDetailsOfInvolvedRow() {
        if (this.detailsOfInvolved.length >= this.maxDetailsOfInvolved) return;
        this.detailsOfInvolved.push({
          name: '',
          organisation: '',
          position: '',
          cv: ''
        });
      },
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      }
    },
    watch: {
      detailsOfIndividuals(value) {
        GrantForm.revisionModel.technical.detailsOfIndividuals = value;
      },

      detailsOfInvolved(value) {
        GrantForm.revisionModel.technical.detailsOfInvolved = value;
      }
    },
    mounted() {
      this.addDetailsOfIndividualsRow();
      this.addDetailsOfInvolvedRow();

      if (GrantForm.revisionModel.technical.detailsOfIndividuals) {
        this.detailsOfIndividuals = GrantForm.revisionModel.technical.detailsOfIndividuals;
      }

      if (GrantForm.revisionModel.technical.detailsOfInvolved) {
        this.detailsOfInvolved = GrantForm.revisionModel.technical.detailsOfInvolved;
      }
    }
  }
</script>
<style scoped>
  .vertical-align-baseline {
    vertical-align: baseline;
  }
</style>
